/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

//
// ...this is not how to do this...
//
// Leaving it here in case it's holding up half the universe or
// something but should be removed when Remote Upload is working
// and stable.
//

// angular.module('prism-ui.components.data').factory('MediaInfoResourceFactory', function ($window: JS5Object) {
//     return $window.MediaInfo;
// });

let delete_me = () => {};
